import { useSelector } from 'react-redux'
import { useOrderViolationTexts } from '@/intl'
import { preview } from '@/components/form/preview'
import { selectRmVehicles } from '@/features/domain/vehicle'
import { getColorValue } from '@/styles'
import { SvgIcon } from '@mui/material'
import { BulkViewData } from '../../hooks/useBulkViewData/types'
import { useTexts } from './hooks/useTexts'

type Props = {
  bulkData: BulkViewData
}

export function Vehicle(props: Props) {
  const {
    bulkData: { vehicleId, violations },
  } = props

  const vehicles = useSelector(selectRmVehicles)
  const texts = useTexts()

  const { getViolationText } = useOrderViolationTexts()

  if (vehicleId === 'mixed') {
    return (
      <preview.Field label={texts.vehicle.label}>
        <preview.MixValue />
      </preview.Field>
    )
  }

  if (!vehicleId) {
    return (
      <preview.Field label={texts.vehicle.label}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  const vehicle = vehicles[vehicleId]

  const hasViolations = violations?.has('VE')
  const color = getColorValue(vehicle.color)

  return (
    <preview.Field label={texts.vehicle.label}>
      <preview.ViolationContainer
        violation={
          hasViolations ? <preview.ViolationBadge tooltip={getViolationText('VE')} /> : null
        }
      >
        {color && <VehicleAvatar color={color} />}
        {vehicle.externalId}
      </preview.ViolationContainer>
    </preview.Field>
  )
}

type VehicleAvatarProps = {
  color: string
  borderColor?: string
}

function VehicleAvatar(props: VehicleAvatarProps) {
  const { color, borderColor = '#fff' } = props
  const rad = 12

  return (
    <SvgIcon>
      <circle cx={rad} cy={rad} r={rad} fill={borderColor} />
      <circle cx={rad} cy={rad} r={rad - 2} fill={color} />
    </SvgIcon>
  )
}
